import type React from 'react';
import SparkleIcon from '../CustomIcons/SparkleIcon';
import PillButton from '../PillButton';

export interface ChangeReviewJumpProps {
    /** What the chip points at, e.g. a field or capability name. */
    label: string;
    /** Jumps the page to what changed. Without it the chip only names the change. */
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
}

/**
 * A chip naming a specific change, sat at the end of an assistant message — clicking one jumps
 * to the field it touched. It renders inside a chat message but belongs to the review family,
 * since it is provenance chrome rather than conversation content.
 */
const ChangeReviewJump: React.FC<ChangeReviewJumpProps> = ({
    label,
    onClick,
    disabled = false,
    className = '',
}) => (
    <PillButton
        label={label}
        icon={<SparkleIcon size={11} />}
        shape="pill"
        size="small"
        tone="assistant"
        interactive={Boolean(onClick)}
        disabled={disabled}
        onClick={onClick}
        className={className}
    />
);

export default ChangeReviewJump;
export { ChangeReviewJump };
